// src/components/Footer.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { APP_INFO } from "../constants/AppInfo";
import storage from "../utils/storage";
import LoginModal from "../pages/Login/LoginModal";

const Footer = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState("");

  useEffect(() => {
    const token = storage.getAccessToken();
    if (token) {
      setIsLoggedIn(true);
      setToken(token);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const prepaidCardUrl = ``;
  const applyCreditCardUrl = ``;

  const handleNavigation = (path) => {
    if (!isLoggedIn) {
      setShowModal(true);
      return;
    }
    navigate(path);
  };

  // ✅ Helper to protect Recharge & Bill links
  const handleRechargeBillClick = (e, href) => {
    if (!isLoggedIn) {
      e.preventDefault();
      setShowModal(true);
    } else {
      navigate(href);
    }
  };

  return (
    <>
      <footer id="footer" className="bg-white pt-5 pb-4 mt-0">
        <div className="container">
          <div className="row g-4">
            {/* Recharge & Bill Payments */}
            <div className="col-sm-6 col-md">
              <h4 className="text-3 fw-400 mb-3">Recharge & Bill Payments</h4>
              <ul className="nav flex-column">
                {[
                  { title: "Mobile Recharge", href: "/mobile-recharge" },
                  { title: "DTH Recharge", href: "/dth-recharge" },
                  { title: "FasTag Recharge", href: "/bill-payment/Fastag" },
                  {
                    title: "Google Play Redeem Code",
                    href: "/google-play-redeem-code",
                  },
                  {
                    title: "Electricity Bill Payment",
                    href: "/bill-payment/Electricity",
                  },
                  {
                    title: "Mobile Postpaid Bill Payment",
                    href: "/bill-payment/Postpaid",
                  },
                  {
                    title: "Landline Bill Payment",
                    href: "/bill-payment/Landline",
                  },
                  {
                    title: "Broadband Bill Payment",
                    href: "/bill-payment/Broadband",
                  },
                  {
                    title: "Loan Repayment",
                    href: "/bill-payment/Loan Repayment",
                  },
                  { title: "Book Cylinder", href: "/bill-payment/LPG Gas" },
                  { title: "Insurance", href: "/bill-payment/Insurance" },
                  { title: "Water", href: "/bill-payment/Water" },
                ].map((item, idx) => (
                  <li className="nav-item" key={idx}>
                    <a
                      className="nav-link"
                      href={item.href}
                      onClick={(e) => handleRechargeBillClick(e, item.href)}
                    >
                      {item.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Financial Services */}
            <div className="col-sm-6 col-md">
              <h4 className="text-3 fw-400 mb-3">Financial Services</h4>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <span
                    className="nav-link"
                    style={{ cursor: "pointer" }}
                    // onClick={() =>
                    //   handleNavigation("/credit-card-to-bank-transfer")
                    // }
                  >
                    Credit Card to Bank Transfer
                  </span>
                </li>
              </ul>
            </div>

            {/* Help Center */}
            <div className="col-sm-6 col-md">
              <h4 className="text-3 fw-400 mb-3">Help Center</h4>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <a className="nav-link" href="/support">
                    Support
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/faq">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div className="col-sm-6 col-md">
              <h4 className="text-3 fw-400 mb-3">Company</h4>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <a className="nav-link" href="/about-us">
                    About Us
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/contact-us">
                    Contact Us
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/privacy-policy">
                    Privacy Policy
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/terms-and-conditions">
                    Terms &amp; Conditions
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/refund-policy">
                    Refund Policy
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/grievance-policy">
                    Grievance Policy
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/faq">
                    FAQ
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/support">
                    Support
                  </a>
                </li>
              </ul>
            </div>

            {/* Download App + Social */}
            <div className="col-12 col-lg-3">
              <h4 className="text-3 fw-400 mb-3">
                Download {APP_INFO.companyName} App
              </h4>
              <div className="d-flex align-items-center mb-3">
                <a
                  href={APP_INFO.appDownloadUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/images/qr-code.png"
                    alt="QR Code"
                    style={{ width: "180px", height: "180px" }}
                  />
                  <img
                    src="/assets/images/playstore-badge.png"
                    alt="Get it on Google Play"
                    style={{ height: "50px" }}
                  />
                </a>
              </div>

              <h4 className="text-3 fw-400 mb-3">Follow us on</h4>
              <ul className="social-icons social-icons-sm social-icons-colored">
                <li className="social-icons-facebook">
                  <a
                    href={APP_INFO.facebookUrl}
                    target="_blank"
                    title="Facebook"
                  >
                    <i className="fab fa-facebook-f" />
                  </a>
                </li>
                <li className="social-icons-whatsapp">
                  <a
                    href={APP_INFO.whatsappUrl}
                    target="_blank"
                    title="Whatsapp"
                    style={{ backgroundColor: "#128c7e" }}
                  >
                    <i className="fab fa-whatsapp" />
                  </a>
                </li>
                <li className="social-icons-instagram">
                  <a
                    href={APP_INFO.instagramUrl}
                    target="_blank"
                    title="Instagram"
                  >
                    <i className="fab fa-instagram" />
                  </a>
                </li>
                <li className="social-icons-youtube">
                  <a href={APP_INFO.youtubeUrl} target="_blank" title="Youtube">
                    <i className="fab fa-youtube" />
                  </a>
                </li>
                <li className="social-icons-telegram">
                  <a
                    href={APP_INFO.telegramUrl}
                    target="_blank"
                    title="Telegram"
                  >
                    <i className="fab fa-telegram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* copyright + payments */}
        <div className="footer-copyright pt-4 mt-4">
          <div className="container">
            <div className="row">
              <div className="col-lg d-flex align-items-center">
                <p className="copyright-text text-center text-lg-start">
                  Copyright © {new Date().getFullYear()}{" "}
                  <a href="/">{APP_INFO.companyName}</a>. All Rights Reserved.
                </p>
              </div>
              <div className="col-lg d-flex align-items-center align-items-lg-end flex-column">
                <ul className="payments-types">
                  <li>
                    <img
                      src="/assets/images/payment/upi.png"
                      alt="upi"
                      title="UPI"
                    />
                  </li>
                  <li>
                    <img
                      src="/assets/images/payment/rupay.png"
                      alt="rupay"
                      title="Rupay"
                    />
                  </li>
                  <li>
                    <img
                      src="/assets/images/payment/visa.png"
                      alt="visa"
                      title="Visa"
                    />
                  </li>
                  <li>
                    <img
                      src="/assets/images/payment/american.png"
                      alt="amex"
                      title="American Express"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Login Modal */}
      <LoginModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onLoginSuccess={() => setIsLoggedIn(true)}
      />
    </>
  );
};

export default Footer;
